import { FC, ReactNode, useEffect } from 'react';
import useApp from '../../hooks/use-app.hook';
import { Box, Stack } from '@mui/material';
import { UseQueryResult } from 'react-query';
import useQueryHelper from '../../hooks/use-query-helper';
import Loader from '../loader';
import { BreadCrumb } from '../app-header/helpers';

export interface PageProps {
  children?: ReactNode;
  title?: string;
  query?: UseQueryResult;
  breadcrumb?: BreadCrumb | BreadCrumb[];
  pageMenu?: ReactNode;
  fullHeight?: boolean;
  loading?: boolean;
}

const Page: FC<PageProps> = ({
  children,
  title = '',
  breadcrumb,
  pageMenu,
  query,
  fullHeight = true,
  loading = false,
}) => {
  const { setPageTitle, setPageMenu } = useApp();
  useEffect(() => {
    setPageTitle(title, breadcrumb);
  }, [setPageTitle, title, breadcrumb]);

  useEffect(() => {
    setPageMenu(pageMenu || null);
    return () => setPageMenu(null);
  }, [setPageMenu, pageMenu]);

  const { showLoader } = useQueryHelper(query);

  // reset scroll
  useEffect(() => {
    const nodes = document.getElementsByTagName('main');
    if (nodes.length) {
      nodes[0].scrollTo(0, 0);
    }
  }, []);

  const isLoading = loading || showLoader;

  return (
    <Box height="100%" width="100%">
      {isLoading ? (
        <Loader />
      ) : (
        <Stack height={fullHeight ? '100%' : 'auto'} boxSizing="border-box" pb={fullHeight ? 0 : 3}>
          {children}
        </Stack>
      )}
    </Box>
  );
};

export default Page;
